module.exports = {
    "idPrimary": 187980,
    "dateCreation": "2019-08-19 08:02:51",
    "dateModification": "2021-01-26 15:54:25",
    "idCompany": "d2dbadb1",
    "idRegion": "d9ac5e8d45",
    "idBranch": "32517238",
    "idUser": 1384274,
    "isInternational": 0,
    "branchAddress1": "4901 N Beach Street",
    "branchAddress2": "",
    "branchAdmin1Email": "",
    "branchAdmin1Name": "",
    "branchAdmin1Phone": "",
    "branchAdmin2Email": "",
    "branchAdmin2Name": "",
    "branchAdmin2Phone": "",
    "branchCity": "Fort Worth",
    "branchCode": "",
    "branchCountry": "US",
    "branchDisplayCustom1": "",
    "branchDisplayCustom2": "",
    "defaultOrResident": 1,
    "branchDisplay1": "Acme Demo Office",
    "branchDisplay2": "1301 NE Loop 820",
    "branchDisplay3": "Fort Worth, TX 76131",
    "branchDisplay4": "PH: 866.977.3627",
    "branchDisplay5": "OFF: 214-334-7745",
    "branchDisplay6": "xpressdocs.com",
    "branchEmail": "info@xpressdocs.com",
    "branchFax": "",
    "branchIdentifier": "a451d96168ed99ad36e73e3299b0c518",
    "branchManagerName": "",
    "branchManagerEmail": "",
    "branchManagerPhone": "",
    "branchName": "Demo Office",
    "branchPhone1": "866.977.3627",
    "branchPhone2": "",
    "branchRandom": "3853",
    "branchRegistered": 0,
    "branchState": "TX",
    "branchWebsite": "",
    "branchZip": "76137",
    "branchActive": 1,
    "branchPickupAvailable": 1,
    "branchDeleted": 0,
    "branchLinkId": "32517238",
    "branchLegalName": "Demo Office",
    "branchCustomLabel1": "",
    "branchCustomLabel2": "",
    "customLogoBw": "",
    "customLogoBw1": "",
    "customLogoClr": "",
    "customLogoClr1": "",
    "copayMethod": 0,
    "addressListTypes": ["upload", "radius", "street", "targeted single", "saturation", "targeted multiple", "CRM", "co-op/condo building"],
    "enableUvSide2": "0",
    "enableVouchers": 0,
    "vhtPhotos": 0,
    "showReceipt": 1,
    "allowNewProofing": 2,
    "enableEmail": 0,
    "enableLicenseNumber": 0,
    "flowthruOrigin": "",
    "avalaraUsageType": "",
    "nonProfitStatus": 0,
    "enableSocialmadesimple": 0,
    "enableNewEmail": 2,
    "allowAddListing": 0,
    "rezoraUrl": "",
    "allowFeedUpdate": 1,
    "uspsCustRegId": "",
    "enableMyListing": 2,
    "orderCleanupNotificationLevel": null,
    "allowBulkMailPermit": 2,
    "customInactiveUserMessage": "",
    "promoLogoLandscape": "",
    "promoLogoPortrait": "",
    "xmDbaLogo1": "",
    "xmDbaLogo2": "",
    "xmDbaLogo3": "",
    "shippingServices": "",
    "costCenterNum": "",
    "assignedDomain": "",
    "domainWrap": 0,
    "crmSource": 1,
    "vatNo": "",
    "logoBw1Asset": 24206008,
    "logoClr1Asset": 24206008,
    "logoBw2Asset": 24206008,
    "logoClr2Asset": 24206008,
    "logoBw3Asset": null,
    "logoClr3Asset": null,
    "imageGallery": {"logos": []},
    "logos": {
        "logoBw1Asset": "https://assets.awsdev.xpressdocs.com/pictures/logo/2020/06/05/4/24206008o.jpg",
        "logoClr1Asset": "https://assets.awsdev.xpressdocs.com/pictures/logo/2020/06/05/4/24206008o.jpg",
        "logoBw2Asset": "https://assets.awsdev.xpressdocs.com/pictures/logo/2020/06/05/4/24206008o.jpg",
        "logoClr2Asset": "https://assets.awsdev.xpressdocs.com/pictures/logo/2020/06/05/4/24206008o.jpg",
        "logoBw3Asset": "",
        "logoClr3Asset": ""
    },
    "orgPrefs": []
};